<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Calibration Certificate Delivery Records</h5>
     <br/>
     <br/>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Certificate()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button routerLink="/CertifivateDeliveryForm" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register New Information </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Delivery Date</th>
              <th>Description</th>
              <th>Payment Status</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_List_Delivery
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems:Data_List_Delivery.length
                      }
            ">
             <td>{{Data_List_Delivery.indexOf(item)+1}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.status}}</td>
              <td>{{item.username}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" [routerLink]="['/CertifivateDeliveryForm',{id:item.id}]"><i class="fa fa-eye"></i> View </a>
                        <a *ngIf="item.payed==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-money"></i> Payment </a>
                      </div>
                  </div>

              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<ng-template #template>
  <div class="modal-header">
     <h4  class="modal-title pull-left">Confirm Delivery Receipt Payment </h4>

     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Pay.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button  type="button" class="btn btn-warning" (click)="PayedRecord(Data_List_Delivery_seletect)"> Confirm Payment <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Pay.hide()">Close</button>
  </div>
</ng-template>
